import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import axios from 'axios';
import { API, useAuth } from '../App';

/**
 * Top-of-page banner shown to logged-in users whose Stripe subscription
 * has been scheduled to cancel at period end, and who need to re-subscribe
 * via Revolut to keep access after that date.
 */
const MigrationBanner = () => {
  const { i18n } = useTranslation();
  const { user, token } = useAuth();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!user || !token) return;
    axios
      .get(`${API}/my-migration-status`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setStatus(res.data))
      .catch(() => setStatus(null));
  }, [user, token]);

  if (!status?.migration_pending) return null;

  const endDate = status.current_period_end ? new Date(status.current_period_end).toLocaleDateString() : '';

  return (
    <div className="bg-gradient-to-r from-orange-500/20 to-red-500/20 border-b border-orange-500/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-white">
          <AlertCircle className="text-orange-400 flex-shrink-0" size={20} />
          <p className="text-sm">
            {i18n.language === 'el' ? (
              <>
                Η συνδρομή σας παραμένει ενεργή μέχρι <strong>{endDate}</strong>.
                Μετά από αυτήν την ημερομηνία, για συνέχιση της πρόσβασης απαιτείται νέα συνδρομή μέσω <strong>Revolut</strong>.
              </>
            ) : (
              <>
                Your subscription remains active until <strong>{endDate}</strong>.
                After that date, please re-subscribe via <strong>Revolut</strong> to keep access.
              </>
            )}
          </p>
        </div>
        <Link to="/pricing">
          <button
            data-testid="migration-cta-btn"
            className="flex-shrink-0 bg-[#0075EB] hover:bg-[#005BB8] text-white text-sm px-4 py-2 rounded-sm font-medium transition-colors"
          >
            {i18n.language === 'el' ? 'Ενεργοποίηση τώρα' : 'Activate now'}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default MigrationBanner;
